// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsRenterGuarantorCompanyWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { CappsRenterGuarantorCompanyWebApiHandler_saveGuarantorCompany } from '@zg-rentals/ts-capps-client';

import type { SaveGuarantorCompanyWebApiRequestDto } from '@zg-rentals/ts-capps-client';

export interface CappsRenterGuarantorCompanyWebApiHandler_saveGuarantorCompany_Args {
  postData: SaveGuarantorCompanyWebApiRequestDto;
}

export type CappsRenterGuarantorCompanyWebApiHandler_saveGuarantorCompany_Options = UseMutationOptions<
  void,
  unknown,
  CappsRenterGuarantorCompanyWebApiHandler_saveGuarantorCompany_Args
>;

export const useCappsRenterGuarantorCompanyWebApiHandler_saveGuarantorCompany = ({
  httpClient,
  ...options
}: Omit<CappsRenterGuarantorCompanyWebApiHandler_saveGuarantorCompany_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsRenterGuarantorCompanyWebApiHandler_saveGuarantorCompany_Args) =>
      CappsRenterGuarantorCompanyWebApiHandler_saveGuarantorCompany(args.postData, httpClient),
  });
};
